import { ISOs } from 'utils/form/constants';

export const DEFAULT_BILLING_COUNTRY = ISOs.USA;
